import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        ns: [`common`, `disclaimer`, `signup`, `arrears-payment`],
        defaultNS: `common`,
        lng: `en`,
        fallbackLng: `en`,
        debug: process.env.REACT_APP_NTUC_TARGET == `demo`,
        backend: { loadPath: `/App/locales/{{lng}}/{{ns}}.json` },
        react: {
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: [`br`, `strong`, `i`, `p`, `li`],
            // https://reactjs.org/docs/concurrent-mode-suspense.html
            // https://react.i18next.com/latest/usetranslation-hook#not-using-suspense
            useSuspense: true,
        },
    })

export default i18n